var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChallengeEndedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14759_51027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9758 12.8778V25.2722H4.02414V12.8778C4.02414 11.0251 5.0672 9.41543 6.59959 8.60738C7.27243 8.25004 8.03863 8.04883 8.85311 8.04883H71.1469C72.9996 8.04883 74.6092 9.09189 75.4173 10.6243C75.7746 11.2971 75.9758 12.0633 75.9758 12.8778Z",
    fill: "#FD646F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 8.04883V17.0629C23.34 17.9514 22.6189 18.6726 21.7304 18.6726H14.326C13.4374 18.6726 12.7163 17.9514 12.7163 17.0629V8.04883H23.34Z",
    fill: "#FC4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7082 8.04883V17.0629C64.7082 17.9514 63.9871 18.6726 63.0986 18.6726H55.6942C54.8056 18.6726 54.0845 17.9514 54.0845 17.0629V8.04883H64.7082Z",
    fill: "#FC4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59959 8.60742V25.2722H4.02414V12.8778C4.02414 11.0251 5.0672 9.41547 6.59959 8.60742Z",
    fill: "#FC4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2233 34.9004H25.505C25.9494 34.9004 26.3098 35.2608 26.3098 35.7052V43.9869C26.3098 44.4313 25.9494 44.7917 25.505 44.7917H17.2233C16.7789 44.7917 16.4185 44.4313 16.4185 43.9869V35.7052C16.4185 35.2608 16.7789 34.9004 17.2233 34.9004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2233 47.207H25.505C25.9494 47.207 26.3098 47.5674 26.3098 48.0119V56.2952C26.3098 56.7396 25.9494 57.1 25.505 57.1H17.2233C16.7789 57.1 16.4185 56.7396 16.4185 56.2952V48.0119C16.4185 47.5674 16.7789 47.207 17.2233 47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2233 59.5137H25.505C25.9494 59.5137 26.3098 59.8741 26.3098 60.3185V68.6002C26.3098 69.0446 25.9494 69.405 25.505 69.405H17.2233C16.7789 69.405 16.4185 69.0446 16.4185 68.6002V60.3185C16.4185 59.8741 16.7789 59.5137 17.2233 59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5292 34.9004H37.9879C38.4323 34.9004 38.7927 35.2608 38.7927 35.7052V43.9869C38.7927 44.4313 38.4323 44.7917 37.9879 44.7917H29.5292C29.0847 44.7917 28.7243 44.4313 28.7243 43.9869V35.7052C28.7243 35.2608 29.0847 34.9004 29.5292 34.9004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5292 47.207H37.9879C38.4323 47.207 38.7927 47.5674 38.7927 48.0119V56.2952C38.7927 56.7396 38.4323 57.1 37.9879 57.1H29.5292C29.0847 57.1 28.7243 56.7396 28.7243 56.2952V48.0119C28.7243 47.5674 29.0847 47.207 29.5292 47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5292 59.5137H37.9879C38.4323 59.5137 38.7927 59.8741 38.7927 60.3185V68.6002C38.7927 69.0446 38.4323 69.405 37.9879 69.405H29.5292C29.0847 69.405 28.7243 69.0446 28.7243 68.6002V60.3185C28.7243 59.8741 29.0847 59.5137 29.5292 59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0121 34.9004H50.4708C50.9153 34.9004 51.2757 35.2608 51.2757 35.7052V43.9869C51.2757 44.4313 50.9153 44.7917 50.4708 44.7917H42.0121C41.5676 44.7917 41.2072 44.4313 41.2072 43.9869V35.7052C41.2072 35.2608 41.5676 34.9004 42.0121 34.9004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0121 47.207H50.4708C50.9153 47.207 51.2757 47.5674 51.2757 48.0119V56.2952C51.2757 56.7396 50.9153 57.1 50.4708 57.1H42.0121C41.5676 57.1 41.2072 56.7396 41.2072 56.2952V48.0119C41.2072 47.5674 41.5676 47.207 42.0121 47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0121 59.5137H50.4708C50.9153 59.5137 51.2757 59.8741 51.2757 60.3185V68.6002C51.2757 69.0446 50.9153 69.405 50.4708 69.405H42.0121C41.5676 69.405 41.2072 69.0446 41.2072 68.6002V60.3185C41.2072 59.8741 41.5676 59.5137 42.0121 59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5815 35.7052V43.9869C63.5815 44.4313 63.2211 44.7917 62.7766 44.7917H54.495C54.0505 44.7917 53.6901 44.4313 53.6901 43.9869V35.7052C53.6901 35.2608 54.0505 34.9004 54.495 34.9004H62.7766C63.2211 34.9004 63.5815 35.2608 63.5815 35.7052Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.495 47.207H62.7766C63.2211 47.207 63.5815 47.5674 63.5815 48.0119V56.2952C63.5815 56.7396 63.2211 57.1 62.7766 57.1H54.495C54.0505 57.1 53.6901 56.7396 53.6901 56.2952V48.0119C53.6901 47.5674 54.0505 47.207 54.495 47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.495 59.5137H62.7766C63.2211 59.5137 63.5815 59.8741 63.5815 60.3185V68.6002C63.5815 69.0446 63.2211 69.405 62.7766 69.405H54.495C54.0505 69.405 53.6901 69.0446 53.6901 68.6002V60.3185C53.6901 59.8741 54.0505 59.5137 54.495 59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02414 24.1445V75.1707C4.02414 77.8379 6.18591 79.9997 8.85311 79.9997H71.1469C73.8141 79.9997 75.9758 77.8379 75.9758 75.1707V24.1445H4.02414Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 1.60966V14.4869C23.34 15.3755 22.6189 16.0966 21.7304 16.0966H16.9014C16.0129 16.0966 15.2917 15.3755 15.2917 14.4869V1.60966C15.2917 0.721127 16.0129 0 16.9014 0H21.7304C22.6189 0 23.34 0.721127 23.34 1.60966Z",
    fill: "#50758D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4185 34.9004H26.3098V44.7917H16.4185V34.9004Z",
    fill: "#FFAC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6901 34.9004H63.5815V44.7917H53.6901V34.9004Z",
    fill: "#FFAC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7243 34.9004H38.7927V44.7917H28.7243V34.9004Z",
    fill: "#FFAC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4185 47.207H26.3098V57.1H16.4185V47.207Z",
    fill: "#FFAC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6901 47.207H63.5815V57.1H53.6901V47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7243 47.207H38.7927V57.1H28.7243V47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4185 59.5137H26.3098V69.405H16.4185V59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6901 59.5137H63.5815V69.405H53.6901V59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7243 59.5137H38.7927V69.405H28.7243V59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2072 34.9004H51.2757V44.7917H41.2072V34.9004Z",
    fill: "#FFAC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2072 47.207H51.2757V57.1H41.2072V47.207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2072 59.5137H51.2757V69.405H41.2072V59.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7082 1.60966V14.4869C64.7082 15.3755 63.9871 16.0966 63.0986 16.0966H58.2696C57.3811 16.0966 56.6599 15.3755 56.6599 14.4869V1.60966C56.6599 0.721127 57.3811 0 58.2696 0H63.0986C63.9871 0 64.7082 0.721127 64.7082 1.60966Z",
    fill: "#50758D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02414 24.1445V75.1707C4.02414 77.8379 6.18591 79.9997 8.85311 79.9997H10.6366C8.3847 79.5908 6.68007 77.6206 6.68007 75.2512V27.5602C6.86197 27.0693 7.3336 26.72 7.88732 26.72H75.9758V24.225V24.1445H4.02414Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4769 16.0966H16.9014C16.0129 16.0966 15.2917 15.3755 15.2917 14.4869V1.60966C15.2917 0.721127 16.0129 0 16.9014 0H17.8672V14.4869C17.8672 15.3755 18.5883 16.0966 19.4769 16.0966Z",
    fill: "#2B597F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8451 16.0966H58.2696C57.3811 16.0966 56.6599 15.3755 56.6599 14.4869V1.60966C56.6599 0.721127 57.3811 0 58.2696 0H59.2354V14.4869C59.2354 15.3755 59.9565 16.0966 60.8451 16.0966Z",
    fill: "#2B597F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14759_51027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeEndedIcon);
export default __webpack_public_path__ + "static/media/challengeEndedIcon.7d7aecdb5db6d7ef0b3a89608d789144.svg";
export { ForwardRef as ReactComponent };